export default __webpack_public_path__ + "static/media/Goal_14.2385294e.zip";